import { TreeViewNode } from '.';

// BFS algorithm to find node by his ID
export function bfsSearch(targetId: string, data: TreeViewNode[]) {
  const queue = [...data];

  while (queue.length > 0) {
    const currNode = queue.shift();
    if (currNode?.id === targetId) {
      return currNode;
    }
    if (currNode?.children) {
      queue.push(...currNode.children);
    }
  }
  return undefined;
}

// Retrieve all ids from node to his children's
export function getAllIds(node: TreeViewNode, idList: string[] = []) {
  idList.push(node.id);
  if (node.children) {
    node.children.forEach((child) => getAllIds(child, idList));
  }
  return idList;
}

// Get IDs of all children from specific node
export function getAllChildren(id: string, data: TreeViewNode[]) {
  const result = bfsSearch(id, data);
  return result ? getAllIds(result) : [];
}

// Get all parent IDs from specific node
export function getAllParents(
  data: TreeViewNode[],
  id: string,
  list: string[] = [],
): string[] {
  const result = bfsSearch(id, data);
  if (result?.parentId) {
    list.push(result.parentId);
    return getAllParents(data, result.parentId, list);
  }
  return list;
}
